"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.alert .bx--modal-container {\n  width: 374px; }\n\n.alert .bx--modal-header {\n  margin-bottom: 0;\n  padding-right: 16px; }\n  .alert .bx--modal-header .bx--modal-header__heading {\n    margin-bottom: 0;\n    font-size: 20px;\n    line-height: 1.3;\n    color: #000000; }\n\n.alert .alert-message {\n  margin-bottom: 16px; }\n\n.alert .bx--modal-content {\n  padding: 16px;\n  margin-bottom: 0; }\n\n@media (max-width: 671px) {\n  .alert .bx--modal-container {\n    position: static;\n    max-width: 84%;\n    height: auto;\n    max-height: 90%; } }\n";
  const fileName = "Alert_Alert";
  const element = document.querySelector("style[data-sass-component='Alert_Alert']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Alert = props => {
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Modal, {
    open: props.open,
    className: 'alert',
    passiveModal: true,
    onRequestClose: props.onRequestClose,
    modalHeading: props.alertHeading
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "alert-message"
  }, props.alertMessage));
};
Alert.propTypes = {
  open: _propTypes.default.bool.isRequired,
  alertHeading: _propTypes.default.string.isRequired,
  alertMessage: _propTypes.default.string.isRequired,
  onRequestClose: _propTypes.default.func.isRequired
};
var _default = exports.default = Alert;